import { createWebHistory, createRouter } from "vue-router";
import {
    CHANGE_PASSWORD_ROUTE,
    CONTACT_ROUTE,
    DETAILS_ROUTE,
    FAQ_ROUTE,
    FAVORITE_ROUTE,
    GENERAL_CONDITION_ROUTE,
    HOME_ROUTE,
    LEGAL_ROUTE,
    LOGIN_ROUTE,
    REGISTER_ROUTE,
    RESULT_ROUTE,
    SAVED_SEARCH_ROUTE,
    SAVE_SEARCH_ROUTE,
    SEARCH_ROUTE, FORGOT_PASSWORD_ROUTE,
    RESET_PASSWORD_ROUTE,
    DEMAT_ROUTE,
    ESPACE_FOURNISSEURS_ROUTE, ESPACE_ACHETEURS_ROUTE
} from "./routes";

const DEFAULT_TITLE = "Portail Marchés";
const DEFAULT_DESCRIPTION = "Portail Marchés : trouvez des appels d'offres publics et avis de marchés en France. Accompagnement expert pour répondre et remporter vos marchés publics, PME et fournisseurs.";

const routes = [
    {
        path: LOGIN_ROUTE,
        name: "login",
        component: () => import('../components/auth/LoginView.vue'),
        meta: { noindex: true },
    },
    {
        path: REGISTER_ROUTE,
        component: () => import('../components/register/RegisterView.vue'),
        meta: { noindex: true },
    },
    {
        path: SAVED_SEARCH_ROUTE,
        name: "searchSaveList",
        component: () => import('../components/search/saved/SearchListView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: SAVE_SEARCH_ROUTE,
        name: "searchSave",
        component: () => import('../components/search/saved/SearchSaveView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: SEARCH_ROUTE,
        name: 'search',
        component: () => import('../components/search/SearchView.vue'),
        meta: {
            title: "Recherche d'appels d'offres publics | Portail Marchés",
            description: "Recherchez des appels d'offres publics et des avis de marchés en France par mots-clés, secteur d'activité, région ou acheteur public.",
        },
    },
    {
        path: RESULT_ROUTE,
        name: "result",
        component: () => import('../components/search/ResultView.vue'),
        meta: { noindex: true },
    },
    {
        path: DETAILS_ROUTE,
        name: "details",
        component: () => import('../components/avis/detailsView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: FAVORITE_ROUTE,
        name: "favorites",
        component: () => import('../components/favorites/FavoriteListView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: FORGOT_PASSWORD_ROUTE,
        name: "forgotPassword",
        component: () => import('../components/password/ForgotPasswordView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: CHANGE_PASSWORD_ROUTE,
        name: "changePassword",
        component: () => import('../components/password/ChangePasswordView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: RESET_PASSWORD_ROUTE,
        name: "resetPassword",
        component: () => import('../components/password/ResetPasswordView.vue'),
        props: true,
        meta: { noindex: true },
    },
    {
        path: LEGAL_ROUTE,
        name: "legal",
        component: () => import('../components/staticPages/LegalView.vue'),
        meta: {
            title: "Mentions légales | Portail Marchés",
            description: "Mentions légales du site Portail Marchés, plateforme de recherche de marchés publics et d'accompagnement aux appels d'offres.",
        },
    },
    {
        path: FAQ_ROUTE,
        name: "faq",
        component: () => import('../components/staticPages/FaqView.vue'),
        meta: {
            title: "FAQ – Questions fréquentes sur les marchés publics | Portail Marchés",
            description: "Retrouvez les réponses aux questions fréquentes sur les marchés publics, les appels d'offres et l'utilisation de Portail Marchés.",
        },
    },
    {
        path: CONTACT_ROUTE,
        name: "contact",
        component: () => import('../components/staticPages/ContactView.vue'),
        meta: {
            title: "Contactez-nous | Portail Marchés",
            description: "Contactez l'équipe de Portail Marchés pour toute question sur notre accompagnement aux marchés publics et appels d'offres.",
        },
    },
    {
        path: GENERAL_CONDITION_ROUTE,
        name: "generalConition",
        component: () => import('../components/staticPages/GeneralConditionView.vue'),
        meta: {
            title: "Conditions générales d'utilisation | Portail Marchés",
            description: "Conditions générales d'utilisation de Portail Marchés, plateforme de marchés publics et d'accompagnement aux appels d'offres.",
        },
    },
    {
        path: DEMAT_ROUTE,
        name: "demat",
        component: () => import('../components/staticPages/DematView.vue'),
        meta: {
            title: "Dématérialisation des marchés publics | Portail Marchés",
            description: "Tout savoir sur la dématérialisation des marchés publics : procédures, obligations légales et outils pour acheteurs et fournisseurs.",
        },
    },
    {
        path: ESPACE_FOURNISSEURS_ROUTE,
        name: "espaceFournisseurs",
        component: () => import('../components/staticPages/EspaceFournisseursView.vue'),
        meta: {
            title: "Espace Fournisseurs – Répondre aux appels d'offres publics | Portail Marchés",
            description: "Espace dédié aux fournisseurs et PME : trouvez des marchés publics, répondez aux appels d'offres et bénéficiez d'un accompagnement personnalisé.",
        },
    },
    {
        path: ESPACE_ACHETEURS_ROUTE,
        name: "espaceAcheteurs",
        component: () => import('../components/staticPages/EspaceAcheteursView.vue'),
        meta: {
            title: "Espace Acheteurs – Gestion des marchés publics | Portail Marchés",
            description: "Espace dédié aux acheteurs publics : publiez vos appels d'offres, gérez vos procédures et simplifiez votre dématérialisation avec Portail Marchés.",
        },
    },
    {
        path: HOME_ROUTE,
        component: () => import('../components/main/MainView.vue'),
        meta: {
            title: "Portail Marchés – Appels d'offres publics & Accompagnement",
            description: DEFAULT_DESCRIPTION,
        },
    },
]

const index = createRouter({
    mode: 'history',
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
    linkActiveClass: 'active',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
})

index.beforeEach((to, from, next) => {
    if (to.path !== LOGIN_ROUTE && to.path !== CHANGE_PASSWORD_ROUTE && to.path !== RESET_PASSWORD_ROUTE && to.path !== FORGOT_PASSWORD_ROUTE) {
        localStorage.setItem('lastRoute', to.fullPath);
    }
    next();
});

index.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
        metaDescription.setAttribute('content', to.meta.description || DEFAULT_DESCRIPTION);
    }

    let metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
        metaRobots.setAttribute('content', to.meta.noindex ? 'noindex, nofollow' : 'index, follow');
    }

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
        ogTitle.setAttribute('content', to.meta.title || DEFAULT_TITLE);
    }

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
        ogDescription.setAttribute('content', to.meta.description || DEFAULT_DESCRIPTION);
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
        ogUrl.setAttribute('content', `https://portailmarches.fr${to.path}`);
    }
});

export default index;
